<template>
  <div>
    <list
      row-key="StudentId"
      ref="list"
      unit="学生"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      form-label-width="90px"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="入学学期" v-if="showTerm">
          <el-select v-model="params.TermId">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input v-model="params.FullName" placeholder="请输入学生姓名" clearable />
        </el-form-item>
        <el-form-item label="学生编号">
          <el-input v-model="params.StudentNumber" placeholder="请输入学生编号" clearable />
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="params.IdCardNo" placeholder="请输入身份证号" clearable />
        </el-form-item>
        <el-form-item label="卡号">
          <el-input v-model="params.CardNumber" type="number" placeholder="请输入卡号" clearable />
        </el-form-item>
        <el-form-item label="家长姓名">
          <el-input v-model="params.ParentName" placeholder="请输入家长姓名" clearable />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="params.ContactNumber" placeholder="请输入联系电话" clearable />
        </el-form-item>
        <el-form-item label="已绑定微信">
          <el-select v-model="params.IsBind" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采集状态">
          <!-- 未采集/审核中/审核成功/审核失败 -->
          <el-select v-model="params.FaceStatus" clearable>
            <el-option label="未采集" :value="0"></el-option>
            <el-option label="审核中" :value="1"></el-option>
            <el-option label="审核成功" :value="2"></el-option>
            <el-option label="审核失败" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="TermName" label="入学学期" min-width="130px" v-if="showTerm" />
        <el-table-column prop="StudentNumber" label="学生编号" min-width="120px" />
        <el-table-column prop="FullName" label="姓名" min-width="120px" />
        <el-table-column prop="Sex" label="性别">
          <template slot-scope="{row}">
            <span v-if="row.Sex==0"></span>
            <span v-else-if="row.Sex==1">男</span>
            <span v-else-if="row.Sex==2">女</span>
          </template>
        </el-table-column>
        <el-table-column prop="IdCardNo" label="身份证号" min-width="150px" />
        <el-table-column prop="CurrentSeatNumber" label="当前学号" min-width="120px">
          <template slot-scope="{row}">
            <span v-if="row.CurrentSeatNumber==0"></span>
            <span v-else>{{row.CurrentSeatNumber}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CurrentClassName" label="当前班级" min-width="110px" />
        <el-table-column prop="SubjectGroup" label="科目组合" min-width="90px" />
        <el-table-column prop="CurrentDormitory" label="当前宿舍" min-width="120px" />
        <el-table-column prop="FaceStatus" label="采集状态" align="center" min-width="80px">
          <div slot-scope="{row}">
            <span v-if="row.FaceStatus==0">未采集</span>
            <span v-if="row.FaceStatus==1">审核中</span>
            <span v-if="row.FaceStatus==2">审核成功</span>
            <span v-if="row.FaceStatus==3">审核失败</span>
          </div>
        </el-table-column>
        <el-table-column prop="ParentName1" label="家长姓名1" min-width="90px" />
        <el-table-column prop="Alias1" label="称呼1" min-width="90px" />
        <el-table-column prop="ContactNumber1" label="联系电话1" min-width="120px" />
        <el-table-column prop="ParentName2" label="家长姓名2" min-width="90px" />
        <el-table-column prop="Alias2" label="称呼2" min-width="90px" />
        <el-table-column prop="Call2" label="联系电话2" min-width="120px" />
        <el-table-column prop="ParentName3" label="家长姓名3" min-width="90px" />
        <el-table-column prop="Alias3" label="称呼3" min-width="90px" />
        <el-table-column prop="ContactNumber3" label="联系电话3" min-width="120px" />
        <el-table-column prop="VerCode" label="验证码" min-width="90px" />
        <el-table-column prop="CardNumber" label="卡号" min-width="90px" />
        <el-table-column prop="VoiceRemark" label="语音备注" min-width="120px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, exportDialog },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    showTerm: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/st/student").default,
      termApi: require("@/api/ed/term").default,
      params: {
        StudentNumber: "",
        FullName: "",
        IdCardNo: "",
        TermId: "",
        ParentName: "",
        ContactNumber: "",
        IsBind: null,
        FaceStatus: null,
        CardNumber: "",
      },
      termList: [],
    };
  },
  beforeMount() {
    this.termApi.list({}).then((res) => {
      if (res.Code == 0) {
        this.termList = res.Data;
      }
    });
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    export() {
      // this.$refs.exportDialog.open().then((that) => {
      //   that.getData(this.params);
      // });
      this.api.export(
        this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams)
      );
    },
  },
};
</script>